import { useQuery } from '@tanstack/react-query';
import {
  getMyPilotRatedMatches,
  getMyPilotRating,
  getMyPilotRatingHistory,
  getRatingPilotContexts,
  getSquadMemberPilotRating,
} from '../lib/ratingPilot';

export const ratingPilotKeys = {
  all: ['rating-pilot'] as const,
  contexts: () => [...ratingPilotKeys.all, 'contexts'] as const,
  mine: (squadId?: number) => [...ratingPilotKeys.all, 'mine', squadId ?? 'latest'] as const,
  history: (squadId: number) => [...ratingPilotKeys.all, 'history', squadId] as const,
  matches: (squadId: number) => [...ratingPilotKeys.all, 'matches', squadId] as const,
  squadMember: (squadId: number, targetUserId: number) => [...ratingPilotKeys.all, 'squad-member', squadId, targetUserId] as const,
};

export function useRatingPilotContexts(enabled: boolean) {
  return useQuery({
    queryKey: ratingPilotKeys.contexts(),
    queryFn: getRatingPilotContexts,
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}

export function useMyPilotRating(enabled: boolean, squadId?: number) {
  return useQuery({
    queryKey: ratingPilotKeys.mine(squadId),
    queryFn: () => getMyPilotRating(squadId),
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}

export function useMyPilotRatingHistory(enabled: boolean, squadId?: number) {
  return useQuery({
    queryKey: ratingPilotKeys.history(squadId ?? 0),
    queryFn: () => getMyPilotRatingHistory(squadId!),
    enabled: enabled && squadId != null,
    staleTime: 60_000,
    retry: false,
  });
}

export function useMyPilotRatedMatches(enabled: boolean, squadId?: number) {
  return useQuery({
    queryKey: ratingPilotKeys.matches(squadId ?? 0),
    queryFn: () => getMyPilotRatedMatches(squadId!),
    enabled: enabled && squadId != null,
    staleTime: 60_000,
    retry: false,
  });
}

export function useSquadMemberPilotRating(enabled: boolean, squadId?: number, targetUserId?: number) {
  return useQuery({
    queryKey: ratingPilotKeys.squadMember(squadId ?? 0, targetUserId ?? 0),
    queryFn: () => getSquadMemberPilotRating(squadId!, targetUserId!),
    enabled: enabled && squadId != null && targetUserId != null,
    staleTime: 60_000,
    retry: false,
  });
}
